import { lazyLoad } from 'utils/loadable';

export const WeeklyMenuPage = lazyLoad(
  () => import('./index'),
  module => module.WeeklyMenuPage,
);
